import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Lightweight probe for `/api/pace/status`. Caches per-mount. Returns
 * `{ paceEnabled, ready }` — `ready=false` before the first response, then
 * `paceEnabled` is a boolean.
 */
export function usePaceStatus() {
  const [state, setState] = useState({ paceEnabled: false, ready: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/pace/status");
        if (!cancelled) setState({ paceEnabled: !!data?.pace_enabled, ready: true });
      } catch {
        if (!cancelled) setState({ paceEnabled: false, ready: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
